import { useNavigate } from 'react-router'
import { useEffect } from 'react'

export const Index = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/settings/company-details')
  }, [navigate])

  return (
    <></>
  )
}
